// src/utils/flags.ts
export const FLAG_MAP: Record<string, string> = {
  italian: 'it',
  indian: 'in',
  mexican: 'mx',
  japanese: 'jp',
  french: 'fr',
  chinese: 'cn',
  thai: 'th',
  american: 'us',
  greek: 'gr',
  spanish: 'es',
  persian: 'ir',
  korean: 'kr',
  vietnamese: 'vn',
  turkish: 'tr',
  german: 'de',
  lebanese: 'lb',
  british: 'gb',
  russian: 'ru',
  polish: 'pl',
  austrian: 'at',
  australian: 'au',
  georgian: 'ge',
  filipino: 'ph',
  swedish: 'se',
};
